"use strict";
import { __exports as u } from "./index.es271.js";
var c;
function o() {
  if (c) return u;
  c = 1;
  function p(r) {
    if (typeof WeakMap != "function") return null;
    var n = /* @__PURE__ */ new WeakMap(), e = /* @__PURE__ */ new WeakMap();
    return (p = function(t) {
      return t ? e : n;
    })(r);
  }
  function f(r, n) {
    if (!n && r && r.__esModule) return r;
    if (r === null || typeof r != "object" && typeof r != "function") return { default: r };
    var e = p(n);
    if (e && e.has(r)) return e.get(r);
    var t = { __proto__: null }, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var i in r)
      if (i !== "default" && Object.prototype.hasOwnProperty.call(r, i)) {
        var a = _ ? Object.getOwnPropertyDescriptor(r, i) : null;
        a && (a.get || a.set) ? Object.defineProperty(t, i, a) : t[i] = r[i];
      }
    return t.default = r, e && e.set(r, t), t;
  }
  return u._ = f, u;
}
export {
  o as __require
};
//# sourceMappingURL=index.es249.js.map
